import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" id=\"icon-download\">\n  <path d=\"M7.5 2.5V10.7812L4.85938 8.14062L4.14062 8.85938L7.64062 12.3594L8 12.7031L8.35938 12.3594L11.8594 8.85938L11.1406 8.14062L8.5 10.7812V2.5H7.5ZM3.5 13.5V14.5H12.5V13.5H3.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol